module.exports = __webpack_public_path__ + "img/bn0714.868ad7e3.png";